import React from 'react';

const DealershipsList = ({dealerships, onItemClick}) => {
    return (
        <div className="cards-dealerships-container">
            {dealerships.map((dealership, index) => {
                const clipId = `clip_dealer_${index}`;
                return (
                    <div className="dealer-card" key={index} onClick={(e) => onItemClick(e, dealership)}>
                        <div className="dealer-card__header">
                            <p className="dealer-name"><strong>{dealership.name}</strong></p>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath={`url(#${clipId})`}>
                                    <path d="M16.01 11H4V13H16.01V16L20 12L16.01 8V11Z" fill="#323232"/>
                                </g>
                                <defs>
                                    <clipPath id={clipId}>
                                        <rect width="24" height="24" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div className="dealer-card__body">
                            <div className="dealer-card__col">
                                <p className="--text-s">{dealership.address}</p>
                                <p className="--text-s">{dealership.phone_numbers}</p>
                            </div>
                            <div className="dealer-card__col">
                                <p className="--text-s dealer-hours">{dealership.open_hours}</p>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    );
}

export default DealershipsList;
